<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="260"
      offset-x
      lazy
    >
      <template v-slot:activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-icon>tune</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <!-- Team -->
          <v-flex xs12 px-2>
            <team-field
              :entityId="entityId"
              v-model="local.teamId"
              :label="$t('action.actions.select', { field: $tc('models.team') })"
              clearable
              chips
              @change="emitChange"
            />
          </v-flex>

          <!-- Ruoli -->
          <v-flex xs12 px-2>
            <v-select
              :items="roleOptions"
              v-model="local.recordRoleTypes"
              multiple
              chips
              clearable
              :label="$tc('models.role', 2)"
              @change="emitChange"
            />
          </v-flex>
        </v-layout>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" flat @click="applyAndClose">
            {{ $t('action.buttons.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import TeamField from '@/components/widgets/Input/TeamField'

export default {
  name: 'EntityUserListFilter',
  components: { TeamField },
  props: {
    entityId: { type: String },
    archived: {
      type: Object,
      default: function () {
        return { teamId: null, recordRoleTypes: [] }
      },
    },
  },
  data: function () {
    return {
      menu: false,
      local: {
        teamId: null,
        recordRoleTypes: [],
      },
      roleOptions: [
        { text: 'Player',      value: 'player' },
        { text: 'Trainer',     value: 'trainer' },
        { text: 'Familiar',    value: 'familiar' },
        { text: 'President',   value: 'president' },
        { text: 'Coordinator', value: 'coordinator' },
      ],
    }
  },
  mounted: function () {
    this.syncFromProp()
  },
  watch: {
    archived: {
      deep: true,
      handler: function () {
        this.syncFromProp()
      },
    },
  },
  methods: {
    syncFromProp: function () {
      this.local.teamId =
        this.archived && this.archived.teamId ? this.archived.teamId : null
      this.local.recordRoleTypes =
        this.archived && Array.isArray(this.archived.recordRoleTypes)
          ? this.archived.recordRoleTypes.slice()
          : []
    },
    emitChange: function () {
      this.$emit('changeArchivedFilters', {
        teamId: this.local.teamId ? this.local.teamId : null,
        recordRoleTypes: Array.isArray(this.local.recordRoleTypes)
          ? this.local.recordRoleTypes
          : [],
      })
      this.$emit('search', this.local.teamId ? this.local.teamId : null)
      this.$emit('setFilters', this.local.teamId ? this.local.teamId : null)
    },
    applyAndClose: function () {
      this.emitChange()
      this.menu = false
    },
  },
}
</script>
